import ConfigurationCaptions from './ConfigurationCaptions';

export default ConfigurationCaptions;
